import type { Base64File } from './Base64FileInput'

export function readAsBase64File(file: File): Promise<Base64File> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () =>
      resolve({
        name: file.name,
        type: file.type,
        size: file.size,
        sizeMB: file.size / 1024 / 1024,
        base64: reader.result as string,
        file,
      })
    reader.onerror = () => reject(reader.error)
    reader.readAsDataURL(file)
  })
}
